export const SWIPER_SPEED = 600;

export enum ArrowDirection {
  LEFT = 'ArrowLeft',
  UP = 'ArrowUp',
  RIGHT = 'ArrowRight',
  DOWN = 'ArrowDown',
}

export const ARROW_BUTTON_SIZE = 30;
export const PREV_ARROW_BUTTON_ID = 'arrow-button-prev';
export const NEXT_ARROW_BUTTON_ID = 'arrow-button-next';

export const THUMBNAIL_SIZE = 45;
export const THUMBNAIL_GAP = 6;
export const THUMBNAIL_BORDER_WIDTH = 2;
